"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = _interopRequireDefault(require("../Button"));
var _SuccessIcon = _interopRequireDefault(require("../SuccessIcon"));
var _excluded = ["isMobile", "isSuccessful", "status", "title", "description", "buttonText", "link", "onClick", "disabled"];
var EmailConfirmation = function EmailConfirmation(props) {
  var isMobile = props.isMobile,
    isSuccessful = props.isSuccessful,
    status = props.status,
    title = props.title,
    description = props.description,
    buttonText = props.buttonText,
    link = props.link,
    onClick = props.onClick,
    disabled = props.disabled,
    otherProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var isLinkOutdated = status === 'email_confirmation_period_expired';
  return /*#__PURE__*/_react["default"].createElement(StyledEmailConfirmation, otherProps, /*#__PURE__*/_react["default"].createElement(_SuccessIcon["default"], {
    size: isMobile ? 45 : 60,
    success: isSuccessful
  }), /*#__PURE__*/_react["default"].createElement(StyledTitle, {
    isMobile: isMobile
  }, title), description && /*#__PURE__*/_react["default"].createElement(StyledDescription, null, description), buttonText && !isLinkOutdated && /*#__PURE__*/_react["default"].createElement(Link, {
    href: link
  }, buttonText), isLinkOutdated && /*#__PURE__*/_react["default"].createElement(StyledButton, {
    primary: true,
    size: "flex",
    onClick: onClick,
    disabled: disabled
  }, buttonText));
};
var StyledEmailConfirmation = _styledComponents["default"].div.withConfig({
  displayName: "EmailConfirmation__StyledEmailConfirmation",
  componentId: "sc-13a4cb4-0"
})(["text-align:center;", ""], function (_ref) {
  var theme = _ref.theme;
  return "\n    ".concat(theme.typography.text1, "\n  ");
});
var StyledTitle = _styledComponents["default"].h1.withConfig({
  displayName: "EmailConfirmation__StyledTitle",
  componentId: "sc-13a4cb4-1"
})(["", ""], function (_ref2) {
  var isMobile = _ref2.isMobile,
    theme = _ref2.theme;
  return "\n    ".concat(theme.typography[isMobile ? 'headline3' : 'headline1'], ";\n    margin-top: ").concat(isMobile ? 6 : 16, "px\n  ");
});
var StyledDescription = _styledComponents["default"].div.withConfig({
  displayName: "EmailConfirmation__StyledDescription",
  componentId: "sc-13a4cb4-2"
})(["color:", ";margin-top:9px;"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.blackLight;
});
var StyledButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "EmailConfirmation__StyledButton",
  componentId: "sc-13a4cb4-3"
})(["", " font-size:inherit;margin-top:12px;min-width:217px;"], function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled && "\n    pointerEvent: none;\n    opacity: 0.7;\n  ";
});
var Link = _styledComponents["default"].a.withConfig({
  displayName: "EmailConfirmation__Link",
  componentId: "sc-13a4cb4-4"
})(["text-decoration:none;margin-top:12px;display:inline-block;color:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.blue;
});
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(EmailConfirmation);